<template>
    <div class="ViewRiskAnalysisBeneficiary" v-loading="loadingPage">
      <HeaderPage>
        <el-button @click="approve" style="height: 44px; margin-left: 1rem" type="success" v-if="['risk_analysis_manually', 'pending', 'risk_analysis_awaiting'].includes(dados.status)" >Aprovar</el-button>
        <el-button @click="reprove" style="height: 44px; margin-left: 1rem" type="danger" v-if="['risk_analysis_manually', 'pending', 'risk_analysis_awaiting'].includes(dados.status)" >Reprovar</el-button>
      </HeaderPage>
      <el-card shadow="never">
        <el-descriptions :title="'Detalhes da Análise de Risco: '+dados.id_status" :column="3" border direction="vertical">
          <template slot="extra">
            <TagStatus :status="dados.status" />
          </template>
        </el-descriptions>
        <el-descriptions :column="3" border direction="vertical">
          <el-descriptions-item label="Titular">{{dados.titular}}</el-descriptions-item>
          <el-descriptions-item label="Documento">{{dados.document}}</el-descriptions-item>
          <el-descriptions-item label="Telefone">{{dados.phone}}</el-descriptions-item>
          <el-descriptions-item label="Email">{{dados.email}}</el-descriptions-item>
          <el-descriptions-item label="Tipo de pessoa">{{ (dados.type_person === 'individual') ? 'Individual' : 'Empresa'  }}</el-descriptions-item>
        </el-descriptions>
        <br><br>
        <el-descriptions  v-if="dados.department_store_id" title="Estabelecimento Comercial" :column="2" border direction="vertical">
          <el-descriptions-item label="Nome do estabelecimento">{{dados.department_store.person.name_store}}</el-descriptions-item>
          <el-descriptions-item v-if="dados.business_cnpj" label="CNPJ">{{ dados.department_sotre.person.business_cnpj }}</el-descriptions-item>
        </el-descriptions>
        <br><br>
        <el-descriptions title="Dados bancários" :column="4" border direction="vertical">
          <el-descriptions-item label="Banco">{{ dados.bank_code }}</el-descriptions-item>
          <el-descriptions-item label="Agência">{{ dados.routing_number }}</el-descriptions-item>
          <el-descriptions-item label="Conta">{{ dados.account_number }}</el-descriptions-item>
          <el-descriptions-item label="Tipo de conta" >
            <span v-if="dados.type === 'payment'">Conta de pagamentos de limite</span>
            <span v-if="dados.type === 'savings'">Conta Poupança</span>
            <span v-if="dados.type === 'checking'">Conta corrente</span>
          </el-descriptions-item>
          <el-descriptions-item label="Tipo de Chave Pix">{{ dados.type_key }}</el-descriptions-item>
          <el-descriptions-item label="Chave Pix">{{ dados.pix_key }}</el-descriptions-item>
        </el-descriptions>
        <br><br>
        <el-descriptions v-if="reproveReasons.length > 0" title="Recusado por" :column="1" border direction="vertical">
          <el-descriptions-item v-for="dados in reproveReasons" :key="dados.code" :label=dados.code>{{dados.text}}</el-descriptions-item>
        </el-descriptions>
        <br><br>
        <AnalysisRules :rules="rules" />
      </el-card>
    </div>
  </template>
  
  <script>
  import {getAnaliseRiscoBeneficiario, putAprovarAnaliseBeneficiario, putReprovarAnaliseBeneficiario} from "@/app/domains/Records/services";
  import {makeErrorFilds} from "@/app/plugins/utils";
  import HeaderPage from "@/app/components/HeaderPage";
  import TagStatus from "@/app/components/Table/TagStatus";
  import AnalysisRules from "@/app/components/RiskAnalysis/AnalysisRules";
  export default {
    name: "ViewRiskAnalysisBeneficiary",
    components: {
      HeaderPage,
      TagStatus,
      AnalysisRules,
    },
    data () {
      return {
        loadingPage: false,
        dados: {
          person: {},
          data: {
            contact: {},
            address: {},
            bank_account: [],
            document: [],
          },
        },
        dados_caf: {},
        rules: {},
        reproveReasons: {},
      }
    },
    methods: {
      init() {
        this.listDados()
      },
      openUrl(url) {
        window.open(url, '_blank')
      },
      async listDados () {
        this.loadingPage = true
        try {
          console.log('analise de risco do beneficiario');
          let response = await getAnaliseRiscoBeneficiario(`/${this.$route.params.id}`)
          this.dados = response.data
          this.dados_caf = response.data_caf
          this.rules = response.rules
          this.reproveReasons = response.reproveReasons
        } catch (e) {
          this.$message({
            showClose: true,
            message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
            type: 'error'
          })
        } finally {
          this.loadingPage = false
        }
      },
      reprove () {
        this.$prompt('Por favor, insira abaixo o motivo para que a conta seja recusada', 'Deseja realmente recusar está conta?', {
          confirmButtonText: "Confirmar Recusa",
          cancelButtonText: "Cancelar",
          type: 'warning',
          inputValidator: function(value) {
            if (value == null) {
              return "Você precisa preencher o motivo.";
            }
          },
        }).then(async (result) => {
            this.loadingPage = true
            try {
              let response = await putReprovarAnaliseBeneficiario(this.$route.params.id, {'status': 'risk_analysis_reproved', 'reason': result.value})
              await this.$router.push({name: 'records.riskAnalysis.index'})
              this.$message({
                showClose: true,
                message: 'Conta atualizada!',
                type: 'success'
              })
            } catch (e) {
              this.$message({
                showClose: true,
                message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
                type: 'error'
              })
            } finally {
              this.loadingPage = false
            }
        });
      },
      approve () {
        this.$confirm('Deseja realmente aprovar está conta?', 'Atenção', {
          center: true,
          confirmButtonText: 'Sim',
          cancelButtonText: 'Não',
          type: 'warning'
        }).then(async () => {
          this.loadingPage = true
          try {
            let response = await putAprovarAnaliseBeneficiario(this.$route.params.id, {'status': 'risk_analysis_approved'})
            await this.$router.push({name: 'records.riskAnalysis.index'})
            this.$message({
              showClose: true,
              message: 'Conta atualizada!',
              type: 'success'
            })
          } catch (e) {
            this.$message({
              showClose: true,
              message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
              type: 'error'
            })
          } finally {
            this.loadingPage = false
          }
        }).catch(() => {});
      }
    },
    mounted() {
      this.init()
    }
  }
  </script>
  
  <style scoped>
  </style>